export enum ToastType {
    Success = 1,
    Error = 2,
    Info = 3,
    Warning = 4
}
